<template>
  <div class="ticket-admin-page">
    <slot 
        :tipo="tipo" :cambiarTipo="cambiarTipo"
        :tickets="tickets" :ticketModal="ticketModal" :abrirTicket="abrirTicket" :ticketTotal="ticketTotal"
        :correos="correos" :abrirCorreo="abrirCorreo"
        :institucion_id="institucion_id" :selectInstituto="selectInstituto"
        :categoria_id="categoria_id" :selectCategoria="selectCategoria"
        :user_id="user_id" :selectUser="selectUser"
        :estado="estado" :selectEstado="selectEstado"
        :correo="correo" :selectCorreo="selectCorreo" :correoTotal="correoTotal" :correoModal="correoModal"
        :correo_estado="correo_estado" :selectCorreoEstado="selectCorreoEstado"
        :correo_institucion_id="correo_institucion_id" :selectCorreoInstitucion="selectCorreoInstitucion"
        :correo_categoria_id="correo_categoria_id" :selectCorreoCategoria="selectCorreoCategoria"
        :responsable_id="responsable_id" :selectCorreoResponsable="selectCorreoResponsable"
        :texto="texto" :atenderCorreo="atenderCorreo"
        :formatearFecha="formatearFecha" :formatearFechaNormal="formatearFechaNormal"
        :mensajes="mensajes" :cerrarCorreo="cerrarCorreo">
    </slot>
  </div>
</template>

<script>
import Axios from 'axios';
import moment from "moment";
moment.locale('es');

export default {
    data() { return {
        tipo: 'ticket',
        tickets: [],
        ticket_index: null,
        ticketTotal: {
            abiertos: null,
            respondidos: null,
            reasignados: null,
            cerrados: null,
        },  
        correos: [],
        correo_index: null,
        correoTotal: {
            sin_responsable: null,
            asignado: null,
            atendido: null,
        },
        institucion_id: null,
        categoria_id: null,
        user_id: null,
        responsable_id: null,
        estado: null,
        correo: null,
        correo_estado: null,
        correo_institucion_id: null,
        correo_categoria_id: null,
        texto: {
            asunto: '',
            correo_asunto: '',
        },
        ticketModal: {},
        correoModal: {},
        mensajes: [],
        adjunto: null,
    }},
    mounted() {
        const vm = this;
        const selectInstitucion = $('#institucion_id');
        const selectCategoria = $('#categoria_id');
        const selectEstado = $('#estado');
        const inputAsunto = $('#asunto');
        const selectCorreoEstado = $('#correo_estado');
        const selectCorreoInstitucion = $('#correo_institucion_id');
        const selectCorreoCategoria = $('#correo_categoria_id');
        const inputCorreoAsunto = $('#correo_asunto');

        const fileInput = $('#fileInput');
        const ticketModalId = $('#ticketModalId');
        const correoModalId = $('#correoModalId');
        const ticketModalFormId = $('#ticketModalFormId');
        
        selectInstitucion.on('change', function() {
            vm.institucion_id = selectInstitucion.val();
            if(vm.institucion_id.length == 0)
                vm.institucion_id = null;
            vm.leerTickets();
        });

        selectCategoria.on('change', function() {
            vm.categoria_id = selectCategoria.val();
            if(vm.categoria_id.length == 0)
                vm.categoria_id = null;
            vm.leerTickets();
        });

        selectEstado.on('change', function() {
            vm.estado = selectEstado.val();
            if(vm.estado.length == 0)
                vm.estado = null;
            vm.leerTickets();
        });

        selectCorreoEstado.on('change', function() {
            vm.correo_estado = selectCorreoEstado.val();
            if(vm.correo_estado.length == 0)
                vm.correo_estado = null;
            vm.leerCorreos();
        });

        selectCorreoInstitucion.on('change', function() {
            vm.correo_institucion_id = selectCorreoInstitucion.val();
            if(vm.correo_institucion_id.length == 0)
                vm.correo_institucion_id = null;
            vm.leerCorreos();
        });

        selectCorreoCategoria.on('change', function() {
            vm.correo_categoria_id = selectCorreoCategoria.val();
            if(vm.correo_categoria_id.length == 0)
                vm.correo_categoria_id = null;
            vm.leerCorreos();
        });

        let timeout = null;
        inputAsunto.on('input', function() {
            
            if (timeout !== null) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function() {
                vm.leerTickets();
            }, 1500);
        });

        let timeout2 = null;
        inputCorreoAsunto.on('input', function() {
            
            if (timeout2 !== null) {
                clearTimeout(timeout2);
            }

            timeout2 = setTimeout(function() {
                vm.leerCorreos();
            }, 1500);
        });

        fileInput.on('change', function(e) {
            const formData = new FormData();
            formData.append('adjunto', e.target.files[0])
            vm.adjunto = formData;
        });

        ticketModalFormId.submit(function(event) {
            event.preventDefault();
            vm.responderTicket();
        });

        vm.leerTickets();        
    },
    methods: {
        cambiarTipo() {
            if(this.tipo == 'ticket') {
                this.tipo = 'correo';
                this.tickets = [];
                this.leerCorreos();
            } 
            else {
                this.tipo = 'ticket';
                this.correos = [];
                this.leerTickets();
            } 
        },
        leerTickets() {
            axios.get('/soporte-admin/getTickets', {params: {
                'institucion_id': this.institucion_id,
                'categoria_id': this.categoria_id,
                'user_id': this.user_id,
                'estado': this.estado,
                'asunto': this.texto.asunto,
            }}).then(res => {
                this.tickets = res.data.tickets;
                this.ticketTotal.abiertos = res.data.abiertos;
                this.ticketTotal.respondidos = res.data.respondidos;
                this.ticketTotal.cerrados = res.data.cerrados;
                this.ticketTotal.reasignados = res.data.reasignados;
            }).catch(e => {
                console.log(e);
            });
        },
        leerCorreos() {
            axios.get('/soporte-admin/getCorreos', {params: {
                'institucion_id': this.correo_institucion_id,
                'categoria_id': this.correo_categoria_id,
                'responsable_id': this.responsable_id,
                'correo': this.correo,
                'estado' : this.correo_estado,
                'asunto': this.texto.correo_asunto,
            }}).then(res => {
                this.correos = res.data.correos;
                this.correoTotal.sin_responsable = res.data.sin_responsable;
                this.correoTotal.asignado = res.data.asignado;
                this.correoTotal.atendido = res.data.atendido;
            }).catch(e => {
                console.log(e);
            });
        },
        formatearFecha(fecha) {           
            return moment(String(fecha)).fromNow()
        },
        formatearFechaNormal(fecha) {
            return moment(String(fecha)).format('DD MMMM YYYY - h:m.a')
        },
        selectCategoria(categoria_id) {
            if(this.categoria_id == null) {
                $('#categoria_id').selectpicker('val', categoria_id);
                this.categoria_id = categoria_id
                this.leerTickets();
            } else {
                $('#categoria_id').selectpicker('val', null);
                this.categoria_id = null;
                this.leerTickets();
            }
        },
        selectInstituto(institucion_id) {
            if(this.institucion_id == null) {
                $('#institucion_id').selectpicker('val', institucion_id);
                this.institucion_id = institucion_id
            } else {
                $('#institucion_id').selectpicker('val', null);
                this.institucion_id = null;
            }
            this.leerTickets();
        },
        selectUser(user_id) {
            if(this.user_id == null) {
                this.user_id = user_id;
            } else {
                this.user_id = null;
            }
            this.leerTickets();
        },
        selectEstado(estado) {
            if(this.estado == null) {
                $('#estado').selectpicker('val', estado);
                this.estado  = estado;
                this.leerTickets();
            } else {
                $('#estado').selectpicker('val', null);
                this.estado = null;
                this.leerTickets();
            }
        },
        abrirTicket(ticket, index) {  
            Axios.get('/soporte-admin/getTicketMensajes/'+ticket.id).then(res => {
                this.ticketModal = ticket;
                this.mensajes = res.data.mensajes;
                this.ticket_index = index;
                $('#ticketModalId').modal('show');
            }).catch(e => {
                console.log(e);
            });
            
        },
        selectCorreo(correo) {
            if(this.correo == null) {
                this.correo = correo;
            } else {
                this.correo = null;
            }
            this.leerCorreos();
        },
        selectCorreoEstado(estado) {
            if(this.correo_estado == null) {
                $('#correo_estado').selectpicker('val', estado);
                this.correo_estado  = estado;
                this.leerCorreos();
            } else {
                $('#correo_estado').selectpicker('val', null);
                this.correo_estado = null;
                this.leerCorreos();
            }
        },
        selectCorreoInstitucion(institucion_id) {
            if(this.correo_institucion_id == null) {
                $('#correo_institucion_id').selectpicker('val', institucion_id);
                this.correo_institucion_id = institucion_id
            } else {
                $('#correo_institucion_id').selectpicker('val', null);
                this.correo_institucion_id = null;
            }
            this.leerCorreos();
        },
        selectCorreoCategoria(categoria_id) {
            if(this.correo_categoria_id == null) {
                $('#correo_categoria_id').selectpicker('val', categoria_id);
                this.correo_categoria_id = categoria_id
                this.leerCorreos();
            } else {
                $('#correo_categoria_id').selectpicker('val', null);
                this.correo_categoria_id = null;
                this.leerCorreos();
            }
        },
        selectCorreoResponsable(responsable_id) {
            if(this.responsable_id == null) {
                this.responsable_id = responsable_id;
            } else {
                this.responsable_id = null;
            }
            this.leerCorreos();
        },
        responderTicket() {
            axios.post('/soporte-admin/responderTicket', this.ticketModal).then(res => {
                this.mensajes = this.mensajes.concat(res.data.mensaje);
                this.ticketModal.descripcion = '';
                if(this.adjunto) {
                    this.adjuntarArchivo(res.data.mensaje.id);
                }
                this.tickets[this.ticket_index].estado = 'respondido'
            }).catch(e => {
                console.log(e);
            });
        },
        adjuntarArchivo(mensaje_id) {
            axios.post('/soporte-admin/adjuntarArchivo/'+mensaje_id, this.adjunto, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(res => {
                this.mensajes[this.mensajes.length -1].adjunto = res.data.adjunto;
                this.adjunto = null;
            }).catch(e => {
                console.log(e);
            });
        },
        abrirCorreo(correo, index) {
            this.correoModal = correo;
            this.correo_index = index;
            $('#correoModalId').modal('show');
        },
        atenderCorreo() {
            axios.post('/soporte-admin/atenderCorreo/'+this.correoModal.id).then(res => {
                this.correos[this.correo_index].responsable_id = res.data.correo.responsable_id;
                this.correos[this.correo_index].responsable = res.data.correo.responsable;
                this.correos[this.correo_index].estado = res.data.correo.estado;
                $('#correoModalId').modal('hide');
            }).catch(e => {
                console.log(e);
            });
        },
        cerrarCorreo() {
            axios.post('/soporte-admin/cerrarCorreo/'+this.correoModal.id).then(res => {
                this.correos[this.correo_index].estado = res.data.correo.estado;
                $('#correoModalId').modal('hide');
            }).catch(e => {
                console.log(e);
            })
        }
    }
};
</script>